import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "chat-content" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "chat-content-box" }

import { DateFormat, FORMAT_TYPE } from "@/services/util/DateFormat";
import { nextTick, reactive, ref, watch } from "vue";
import { EntityMessage } from "@/services/message/entity/api/EntityMessage";
import { useStore } from "vuex";
import { RequestStatusType } from "@/services/datatype/request/RequestStatusType";
import CheckType from "@/utils/CheckType";
import UserTools from "@/services/session/UserTools";
import { ElMessage } from "element-plus";
import order from "@/api/order";
import talk from "@/api/talk";
import Text from "@/components/talkMessage/Text.vue";
import File from "@/components/talkMessage/File.vue";
import Audio from "@/components/talkMessage/Audio.vue";
import Video from "@/components/talkMessage/Video.vue";
import ImgOne from "@/components/talkMessage/Img.vue";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";
import MessageUtil from "@/utils/Message";
interface _dataList {
  //数据
  data: string;
  //创建时间
  createTime: string;
  // 接收状态 true为接收 false为发送
  correlationState: boolean;
  //文件路径
  link: string;
  //文件类型 0图片 1视频 2文件
  linkType: number;
  //文件名称
  fileName: string;
  //状态码
  status: number;
  name: string;
  img: string;
  receiverIndex: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    rid: null,
    attorneyState: { type: Boolean },
    orderState: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  rid: string;
  attorneyState: boolean;
  orderState: boolean;
};

const $store = useStore();
const audioUrl = ref("");
const setAudioUrl = (url) => {
  audioUrl.value = url;
};

const dataList = reactive<_dataList[]>([]);
const getMessage = async (): Promise<void> => {
  let index = 0;
  const getOrder = await order.getOrder(Number(props.rid));
  talk.getMessage(Number(props.rid), async (messages: EntityMessage[]) => {
    console.log (messages,"000000")
    if (
      !getOrder.assistantInfo ||
      !!(
        getOrder?.entitledToAssign &&
        getOrder.delegateAccepted &&
        getOrder.assistantInfo &&
        getOrder.assistantInfo.entityId == UserTools.loginId
      )
    ) {
      await DefaultWebServiceFactory.getInstance()
        .getWebEnterpriseServiceRequestService()
        .enterMessageSessionOnServiceRequest(props.rid);
    }
    if (index != 0) {
      await getChat(messages.filter((value) => value)[0]);
    } else {
      index++;
      let find: any = [];
      messages.forEach((el) => {
        if (!find.find((e) => e.receiverIndex == el.receiverIndex)) {
          find.push(el);
        }
      });
      console.log(find, 88888);
      if (find.length == dataList.length) return;
      dataList.splice(0, dataList.length);
      dataList.length = 0;
      messages.sort((a, b) => a["message"].id - b["message"].id);
      messages.forEach((r) => {
        getChat(r);
      });
    }
  });
};
const getChat = async (messages: EntityMessage): Promise<void> => {
  if (!messages) return;
  if (!$store.state.talk.serviceExpireTime[props.rid]) {
    const getOrder = await order.getOrder(Number(props.rid));
    getOrder.serviceExpireTime &&
      $store.commit("talk/updateServiceExpireTime", {
        id: props.rid,
        time: getOrder.status == 13 ? 11 : getOrder.serviceExpireTime || null,
      });
  }
  let text: string;
  if (messages["message"].data) {
    const isData = [
      [
        messages["message"].data.status,
        RequestStatusType.COMPLETED,
        "用户已确认完成",
      ],
      [messages["message"].data.status, 12, "已完成，待确认"],
      [
        typeof messages["message"].data,
        "object",
        messages["message"].data.resolveNotes,
      ],
      [0, 0, messages["message"].data],
    ];
    text = isData.find((x: any[]) => x[0] == x[1])[2];
  } else {
    text = "";
  }
  const img = messages["message"].senderEntityInfo.logoImgUrl;
  console.log (messages,4444444)
  let data: _dataList = {
    data: text,
    createTime: DateFormat.dateFormatString(
      Number(messages["message"].createTime),
      FORMAT_TYPE.NORMAL4
    ),
    correlationState:
      messages["message"].senderEntityInfo.entityId !== UserTools.loginId,
    link: messages["message"].link,
    linkType: CheckType.checkFileType(messages["message"].link),
    fileName: messages["message"].fileName,
    status: messages["message"].data?.status,
    name: messages["message"].senderEntityInfo.entityName,
    img: img ? CheckType.isImg(img) : require("@/assets/images/Talk/logo.jpg"),
    receiverIndex: messages.receiverIndex,
  };
  data.data === "用户已确认完成" &&
    $store.commit("talk/updateServiceExpireTime", { id: props.rid, time: 11 });
  if (dataList[dataList.length - 1]) {
    if (
      dataList.filter((value) => messages.receiverIndex == value.receiverIndex)
        .length > 0
    ) {
      return;
    }
  }
  dataList.push(data);
  await nextTick(() => {
    let content = document.getElementsByClassName("chat-content")[0];
    setTimeout(
      () => {
        content.scrollTop = content.scrollHeight;
      },
      messages["message"].link ? 300 : 0
    );
  });
};

watch(props, () => {
  getMessage();
  setInterval(() => {
    if (dataList.length == 0) {
      getMessage();
    }
  }, 2000);
  setInterval(() => {
    if (dataList.length == dataList.length) {
      getMessage();
    }
  }, 60000);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["chatting", { right: !item.correlationState }]),
        key: index
      }, [
        _createElementVNode("img", {
          class: "logo",
          src: item.img,
          alt: ""
        }, null, 8, _hoisted_2),
        _createElementVNode("div", {
          class: _normalizeClass([[item.correlationState ? 'chat-left' : 'chat-right'], "chat-content-box-triangle"])
        }, null, 2),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", {
            style: {"font-size":"0.8rem"},
            class: _normalizeClass({ time: !item.correlationState })
          }, _toDisplayString(item.name + "  " + item.createTime), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["chat-content-box-card", { 'card-right': !item.correlationState }])
          }, [
            (item.linkType === 0)
              ? (_openBlock(), _createBlock(Text, {
                  key: 0,
                  item: item,
                  rid: __props.rid
                }, null, 8, ["item", "rid"]))
              : (item.linkType === 1)
                ? (_openBlock(), _createBlock(File, {
                    key: 1,
                    item: item
                  }, null, 8, ["item"]))
                : (item.linkType === 2)
                  ? (_openBlock(), _createBlock(Audio, {
                      key: 2,
                      item: item,
                      url: audioUrl.value,
                      onSetAudioUrl: setAudioUrl
                    }, null, 8, ["item", "url"]))
                  : (item.linkType === 3)
                    ? (_openBlock(), _createBlock(Video, {
                        key: 3,
                        item: item,
                        height: 10
                      }, null, 8, ["item"]))
                    : (_openBlock(), _createBlock(ImgOne, {
                        key: 4,
                        item: item
                      }, null, 8, ["item"]))
          ], 2)
        ])
      ], 2))
    }), 128))
  ]))
}
}

})